<app-admin-student-platform-header></app-admin-student-platform-header>
<section class="user-management">
  <div>
    <div class="header">
      <div>
        <h1 class="page-title">Candidates</h1>
        <p class="subtitle">All candidates who have applied via the BeExpert platform.</p>
      </div>
    </div>

    <!-- TABS -->
    <div class="tabs-header">
      <div class="tabs">
        <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_FRESHER">
        <button
          class="tab"
          [class.active]="activeTab === 'fresher'"
          (click)="setTab('fresher')"
        >
          Fresher
        </button>
        </ng-container>

        <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED">
        <button
          class="tab"
          [class.active]="activeTab === 'experienced'"
          (click)="setTab('experienced')"
        >
          Experienced
        </button>
        </ng-container>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="search-filter-row">
        <!-- Search box -->
        <div class="search-box">
          <span class="material-icons">search</span>
          <input
            type="text"
            placeholder="Search candidates..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
          />
        </div>

        <div class="filter-actions-group" style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
          <!-- Company Filter -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedCompany"
              (change)="onFilterChange()"
              class="filter-select"
            >
              <option *ngFor="let comp of companies" [value]="comp">{{ comp }}</option>
            </select>
          </div>

          <!-- Job/Role Filter -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedJob"
              (change)="onFilterChange()"
              class="filter-select"
            >
              <option *ngFor="let j of jobs" [value]="j">{{ j }}</option>
            </select>
          </div>

          <!-- Status Filter -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedStatus"
              (change)="getCandidates()"
              class="filter-select"
            >
              <option *ngFor="let s of candidateStatuses" [value]="s.value">
                {{ s.label }}
              </option>
            </select>
          </div>

          <!-- Applied Date Filter -->
          <div class="date-filter" style="display: flex; align-items: center; gap: 8px; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; background: white;">
            <span style="font-size: 12px; color: #64748b; font-weight: 500;">Applied Date:</span>
            <input
              type="date"
              [(ngModel)]="selectedDate"
              (change)="onFilterChange()"
              style="border: none; outline: none; font-size: 14px; color: #1e293b; background: transparent; cursor: pointer;"
            />
            <button *ngIf="selectedDate" (click)="clearDateFilter()" style="border: none; background: transparent; cursor: pointer; display: flex; align-items: center; padding: 0;">
              <span class="material-icons" style="font-size: 16px; color: #94a3b8;">close</span>
            </button>
          </div>

          <button class="export-btn" (click)="exportToExcel()">
            <span class="material-icons">download</span>
            Export
          </button>
        </div>
      </div>

      <!-- Loader -->
      <ng-container *ngIf="isLoading">
        <div class="app-spinner">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading">
        <!-- Fresher Candidates Table -->
        <ng-container *ngIf="activeTab === 'fresher'">
          <ng-container *ngIf="candidatesData.length > 0; else showMessage">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>CANDIDATE</th>
                  <th>MOBILE</th>
                  <th>ROLE</th>
                  <th>COMPANY</th>
                  <th>LOCATION</th>
                  <th>
                    <div class="header-cell-sort" (click)="sortBy('assessment_score')">
                      Assessment
                      <span class="material-icons sort-icon">swap_vert</span>
                    </div>
                  </th>
                  <th>
                    <div class="header-cell-sort" (click)="sortBy('ai_interview_score')">
                      AI Interview
                      <span class="material-icons sort-icon">swap_vert</span>
                    </div>
                  </th>
                  <th>STATUS</th>
                  <th>APPLIED</th>
                  <th>RESUME</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let candidate of candidatesData">
                  <td class="company-cell">
                    <div class="avatar" style="background-color:#6366f1">
                      {{ candidate.name ? candidate.name.substring(0,2).toUpperCase() : 'C' }}
                    </div>
                    <div>
                      <strong class="company-name">{{ candidate.name || '—' }}</strong>
                      <span class="contact-email">{{ candidate.email || '—' }}</span>
                    </div>
                  </td>
                  <td>{{ candidate.mobile || '—' }}</td>
                  <td>{{ candidate.job_title || candidate.role || '—' }}</td>
                  <td>{{ candidate.company_name || '—' }}</td>
                  <td>{{ candidate.current_location || candidate.city_pref_1 || '—' }}</td>
                  <td>{{ candidate.assessment_score ?? '—' }}</td>
                  <td>{{ candidate.ai_interview_score ?? '—' }}</td>
                  <td>
                    <span
                      class="badge-dot"
                      [ngClass]="getStatusClass(candidate.status)"
                    >
                      <span class="dot"></span>
                      {{ (candidate.status?.replace('_', ' ') | titlecase) || '—' }}
                    </span>
                  </td>
                  <td>{{ (candidate.created_at | date: 'dd MMM yyyy') || '—' }}</td>
                  <td>
                    <button
                      *ngIf="candidate.resume_url"
                      class="icon-action-btn"
                      (click)="downloadResume(candidate.resume_url)"
                      matTooltip="View Resume"
                    >
                      <span class="material-icons">description</span>
                    </button>
                    <span *ngIf="!candidate.resume_url">—</span>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

            <!-- Pagination Row -->
            <div class="pagination-row">
              <div class="showing-text">
                Showing <strong>{{ candidatesData.length }}</strong> of <strong>{{ total }}</strong>
              </div>
              <div class="pagination-controls">
                <button
                  class="pag-btn"
                  [disabled]="page === 1"
                  (click)="prevPage()"
                >
                  <span class="material-icons">chevron_left</span>
                </button>
                <span class="page-indicator">
                  Page {{ page }} / {{ totalPages }}
                </span>
                <button
                  class="pag-btn"
                  [disabled]="page === totalPages"
                  (click)="nextPage()"
                >
                  <span class="material-icons">chevron_right</span>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Experienced Candidates Table -->
        <ng-container *ngIf="activeTab === 'experienced'">
          <ng-container *ngIf="candidatesData.length > 0; else showMessage">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>CANDIDATE</th>
                  <th>MOBILE</th>
                  <th>ROLE</th>
                  <th>CURRENT TITLE</th>
                  <th>CURRENT CO.</th>
                  <th>APPLIED CO.</th>
                  <th>EXP</th>
                  <th>CURRENT CTC</th>
                  <th>EXPECTED CTC</th>
                  <th>ASSESS.</th>
                  <th>AI</th>
                  <th>STATUS</th>
                  <th>APPLIED</th>
                  <th>RESUME</th>

                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let candidate of candidatesData">
                  <td class="company-cell">
                    <div class="avatar" style="background-color:#6366f1">
                      {{ candidate.name ? candidate.name.substring(0,2).toUpperCase() : 'C' }}
                    </div>
                    <div>
                      <strong class="company-name">{{ candidate.name || '—' }}</strong>
                      <span class="contact-email">{{ candidate.email || '—' }}</span>
                    </div>
                  </td>
                  <td>{{ candidate.mobile || '—' }}</td>
                  <td>{{ candidate.job_title || candidate.role || '—' }}</td>
                  <td>{{ candidate.current_title || '—' }}</td>
                  <td>{{ candidate.current_company || '—' }}</td>
                  <td>{{ candidate.company_name || '—' }}</td>
                  <td>{{ candidate.experience_years ? candidate.experience_years + ' yrs' : '—' }}</td>
                  <td>{{ candidate.current_ctc || '—' }}</td>
                  <td>{{ candidate.expected_ctc || '—' }}</td>
                  <td>{{ candidate.assessment_score ?? '—' }}</td>
                  <td>{{ candidate.ai_interview_score ?? '—' }}</td>
                  <td>
                    <span
                      class="badge-dot"
                      [ngClass]="getStatusClass(candidate.status)"
                    >
                      <span class="dot"></span>
                      {{ (candidate.status?.replace('_', ' ') | titlecase) || '—' }}
                    </span>
                  </td>
                  <td>{{ (candidate.created_at | date: 'dd MMM yyyy') || '—' }}</td>
                  <td>
                    <button
                      *ngIf="candidate.resume_url"
                      class="icon-action-btn"
                      (click)="downloadResume(candidate.resume_url)"
                      matTooltip="View Resume"
                    >
                      <span class="material-icons">description</span>
                    </button>
                    <span *ngIf="!candidate.resume_url">—</span>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

            <!-- Pagination Row -->
            <div class="pagination-row">
              <div class="showing-text">
                Showing <strong>{{ candidatesData.length }}</strong> of <strong>{{ total }}</strong>
              </div>
              <div class="pagination-controls">
                <button
                  class="pag-btn"
                  [disabled]="page === 1"
                  (click)="prevPage()"
                >
                  <span class="material-icons">chevron_left</span>
                </button>
                <span class="page-indicator">
                  Page {{ page }} / {{ totalPages }}
                </span>
                <button
                  class="pag-btn"
                  [disabled]="page === totalPages"
                  (click)="nextPage()"
                >
                  <span class="material-icons">chevron_right</span>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- No Candidates Found Message -->
        <ng-template #showMessage>
          <div class="no-data">
            <span class="material-icons">search_off</span>
            <h3>No candidates found</h3>
            <p>Try adjusting your search query or filters.</p>
            <button class="reset-filter-btn" (click)="resetFilters()">
              <span class="material-icons">restart_alt</span> Clear Filters
            </button>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</section>